import React from 'react';
import FontAwesome from 'react-fontawesome'


const Icon = props => {
	// return <svg { ...props }><use xlinkHref={`/images/icons/icons.svg#si-${props.icon}`}></use></svg>
	return <FontAwesome name={props.icon} {...props} style={{...props.style, padding: "3px", display: 'flex', alignItems: 'center', justifyContent: 'center', ...props.style }}/>

}

export default Icon



// WEBPACK FOOTER //
// ./src/Icons.js